// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"75b24e25","952":"da3f1488"}[chunkId] + ".chunk.js";
};